import React, { useState } from 'react';
import './styles.css';
import axios from 'axios';

export default function Contact() {
    const [status, setStatus]= useState('');
    const [disabled, setDisabled] = useState(false);

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')

    const handleSubmit = (e) => {
        setDisabled(true);
        e.preventDefault();
        axios({
            method: "POST",
            url: "https://www.wjpadvogados.com.br/send",
            data: {
                name,
                email,
                message
            }
        }).then((response) => {
            setDisabled(false);
            if (response.data.status === 'success') {
                setStatus('success')
                alert("Message Sent.");
                resetForm()
            } else if (response.data.status === 'fail') {
                setStatus('fail')
                setDisabled(false);

                alert("Message failed to send.")
            }
        })
    }

    function resetForm() {
        document.getElementById('contact-form').reset();
    }

    return (
        <div className="content content-contact">
            <h2 style={{ textAlign: 'center' }}>Entre em contato conosco. Estamos à disposição!</h2>
            <p style={{ textAlign: 'center' }}>Envie sua mensagem nos campos abaixo:</p>

            <form id="contact-form" onSubmit={handleSubmit}>
                <div className="contact-group">

                    <div className="input-group">
                        <input name="nome" placeholder="Nome" required id="name" value={name} onChange={e => setName(e.target.value)} />
                        <input name="email" placeholder="Email" required id="email" value={email} onChange={e => setEmail(e.target.value)} />
                        <input name="telefone" placeholder="Telefone" required id="telefone" />
                    </div>

                    <textarea rows="10" placeholder="Digite sua mensagem" value={message} onChange={e => setMessage(e.target.value)} name="message" id="mensagem" required />
                </div>

                <button type="submit" disabled={disabled}>{disabled ? 'Enviando...' : 'Enviar Mensagem'}</button>


                {status !== '' && <div className="message"
                    style={status == 'success' ? { backgroundColor: '#2ecc71' } : { backgroundColor: '#f1003b' }}>
                    {message == 'success' ? 'Mensagem enviada com sucesso' : 'Mensagem não pode ser enviada. Tente novamente mais tarde'}
                </div>}


            </form>
        </div>
    );
}
